export default "__VITE_ASSET__b8ad94cb__"